 <template>
 <div v-role="'dir'">
  <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

   <v-row justify="center">
    <v-dialog v-model="dialog1" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Solicitar permissão de acesso a instituição</v-card-title>
        <v-card-text>

            <v-row>

              <v-col md="6">Nome do Usuário:</v-col>
              <v-col md="6"><span class="text-label">{{nomeUsuario}}</span></v-col>
              <v-col md="6">Instituição Actual:</v-col>
              <v-col md="6"><span class="text-label">{{instituicaoDescricao}}</span></v-col>
              <v-col md="6">Instituicao destino:</v-col>
              <v-col md="6"><span class="text-label">{{(dados !== null)?dados.descricao:''}}</span></v-col>
              <v-col md="12">
                <v-select
                :rules="ruleTextRequired"
                :items="tempos"
                v-model="tempoActividade"
                label="Tempo de actividade"
              ></v-select>
              </v-col>
              <v-col md="12">

             <v-textarea
              style="background-color:#F1F0B0"
              v-model="motivoMudanca"
              name="input-7-1"
              label="Porquê deseja acessar a esta instituição ?"
              :hint="200-motivoMudanca.length"
            ></v-textarea>

              </v-col>

            </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" :disabled="(500-(motivoMudanca.length)?motivoMudanca.length:0) < 1 || motivoMudanca === '' || tempoActividade === null" text @click="saveSolicitacaoMudanca()">Concordar</v-btn>
          <v-btn color="green darken-1" text @click="dialog1=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

    <v-row justify="center">
    <v-dialog v-model="dialog2" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Solicitar permissão de acesso a instituição</v-card-title>
        <v-card-text>

            <v-row>

              <v-col>
                <span>Deseja continuar com a  operação ? </span>
              </v-col>

            </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="save()">Concordar</v-btn>
          <v-btn color="green darken-1" text @click="dialog2=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- ======================= Dialogo para alterar o número de uuarios activos de uma instituição =================== -->

    <v-row justify="center">
    <v-dialog v-model="dialogUsuarios" persistent max-width="490">
      <v-card>
        <v-card-title class="headline">Alterar número de usuários activos?</v-card-title>
        <v-card-text>

          <v-container>
            <v-row>
            <v-col md="12">
               <span style="font-size:16px;font-weight:Bold;">Instituicao: {{(obj_instituicao !== null)?obj_instituicao.descricao: ''}}</span>
            </v-col>
            <v-col md="12">
               <span style="font-size:11px;font-weight:Bold;">Usuarios permidos: {{(obj_instituicao !== null)?obj_instituicao.usuarios_permitidos: ''}}</span>
            </v-col>
              <v-col
                cols="12"
                sm="6"
                md="12"
              >
                <v-text-field
                  v-model="numero_usuarios"
                  label="Novo número de usuários"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" :disabled="numero_usuarios === ''" text @click="saveUsuarios()">Concordar</v-btn>
          <v-btn color="green darken-1" text @click="dialogUsuarios=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- ========================================================================================== -->

  <v-sheet class="pa-5">
          <v-toolbar-title>Mudar de Instituicao  </v-toolbar-title>

        <div :style="estiloPauta"
                    v-if="$store.state.hasMessage"
                    :class="$store.state.classMessage"
                  >{{$store.state.textMessage}}</div>
    <v-list>
      <v-col cols="6" sm="6" md="4">

          <!--Search     :rules="ruleTextRequired"-->
 <v-autocomplete
        v-model="searchInDb"

        item-value="idInstituicao"
        item-text="descricao"
        :items="abertInsts"
        label="Pesquisa"
        :readonly="false"
        persistent-hint
        prepend-icon="person"
        @change="copy(searchInDb)"
        return-object
      >
      </v-autocomplete>

          <!--FIM Search-->

      </v-col>
      <v-col cols="6" sm="6" md="8">
            <v-list-item
              v-for="item in abertInsts"
              :key="item.descricao"
              :search="searchInDb"
            >
              <v-list-item-content>
            <v-col cols="12" sm="12" md="12">

                <v-switch   v-model="item.status_2" v-on:click="copy(item)" :label="item.descricao"></v-switch>
                <span style="font-size:12px;">Usuarios Permitidos: {{item.usuarios_permitidos}}</span><v-icon v-if="role === 'ROLE_ADM'"  @click="showDialogoUsuarios(item)" small style="margin-left:10px;">edit</v-icon>
            </v-col>

              </v-list-item-content>

            </v-list-item>
      </v-col>
    </v-list>

  </v-sheet>

 </div>

</template>

<script>
import axios from '../../plugins/axios'
var ls = require('local-storage')
export default {
  data: () => ({
    abertInsts: [],
    estiloPauta: 'position:fixed;background-color:green;color:white;',
    numero_usuarios: '',
    motivoMudanca: '',
    dialog2: false,
    dialog1: false,
    tempoActividade: null,
    tempos: ['30min', '1h', '2h', '3h'],
    descricao: '',
    dialogUsuarios: false,
    resultsInstituicao: [],
    role: ls.get('role'),
    nomeUsuario: ls.get('nomeUsuario'),
    valor: '',
    status_2: false,
    searchInDb: '',
    dialog: false,
    disabled: false,
    dados: null,
    isLoading: true,
    obj_instituicao: null,
    instituicaoDescricao: ls.get('instituicaodescricao'),

    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length >= 2 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],

    editedItem: {
      idInstituicao: 0,
      descricao: '',
      status_2: false

    }

  }),

  created () {
    this.initialize()
    // check if classe has been selected otherwise send back to painel to select
  },

  computed: {
    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    }
  },

  methods: {

    showDialogoUsuarios (item) {
      this.obj_instituicao = item
      this.numero_usuarios = item.usuarios_permitidos
      this.dialogUsuarios = true
    },

    resetar () {
      confirm('Tem certez que quer redefinir as configuracoes de Abertura e fecho ?') &&
        this.aberfechotInstituicaoReset()
    },
    /* Copiar os dados de item para dados */
    async copy (item) {
      this.disabled = false
      // this.dialog = true
      this.dados = item
      this.ObterUltimaSolicitacaoEfectuada().then(() => {
        if (this.resultsInstituicao.length <= 0) {
          this.dialog2 = true
        } else { this.dialog2 = true }
      })
    },

    async saveUsuarios () {
      let params =
      {
        idInstituicao: this.obj_instituicao.idInstituicao,
        numeroUsuario: this.numero_usuarios
      }
      this.isLoading = true

      try {
        let msg = await axios
          .post('/ActualizarUsuariosPermitidos', params)
          .then(res => res.data)

        if (msg.affectedRows >= 1) {
          this.text = 'Operação efectuada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 3000 })

          this.dialogUsuarios = false
          this.initialize()
        } else {
          this.text = 'Ocorreu um erro ao tentar efectuar a operação'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }

        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async   saveSolicitacaoMudanca () {
      this.dialog1 = false

      // this.editedItem=item
      const ls = require('local-storage')

      var params = {
        destino: this.dados,
        motivo: this.motivoMudanca,
        tempoActividade: this.tempoActividade,
        solicitante: ls.get('nomeUsuario'),
        idSolicitacao: 0,
        autor: null,
        estado: null,
        descricao: ls.get('instituicaodescricao')
      }

      try {
        let msg = await axios
          .post('/mudarInstituicaoSolicitacao', params)
          .then(res => res.data)
        // this.text = msg[1].insertId
        try {
          if (msg.affectedRows >= 1) {
            this.estiloPauta = 'position:fixed;background-color:green;color:white;'
            this.text = 'A sua solicitação foi enviada com sucesso, por favor aguarde a aprovação do pedagógico!'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 5000
            })
          }
          // this.Controlo_actividade()
        } catch (error) {}
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false
        this.estiloPauta = 'position:fixed;background-color:green;color:white;'
        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 5000
        })
      } finally {

      }
    },

    async   save () {
      this.dialog = false

      // this.editedItem=item
      const ls = require('local-storage')

      var params = {
        id: this.dados.idInstituicao,
        descricao: this.dados.descricao
      }

      try {
        let msg = await axios
          .post('/mudarInstituicao', params)
          .then(res => res.data)
        ls.set('i_id', this.dados.idInstituicao)
        // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
          // this.Controlo_actividade()
        } catch (error) {}
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
        this.initialize()

        setTimeout(() => {
          this.logout()
        }, 1000)
      }
    },

    logout () {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    async initialize (searchInDb) {
      try {
        this.abertInsts = await axios
          .get('/listarInstituicao')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async ObterUltimaSolicitacaoEfectuada () {
      try {
        let params = {
          usuario: ls.get('nomeUsuario'),
          instituicao: this.dados.idInstituicao
        }
        this.resultsInstituicao = await axios
          .post('/obterUltimaSolicitacao-instituicao', params)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async Controlo_actividade () {
      let params =
      {
        actividade: 'Mudança de Instituição',
        descricao: 'Efectuou a mudança de instuição - Nova instituição : ' + this.dados.descricao
      }

      try {
        let msg = await axios
          .post('/controlo-actividades', params)
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    //

    async aberfechotInstituicaoReset () {
      try {
        let msg = await axios
          .post('/aberfechotInstituicaoReset')
          .then(res => res.data)
          // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        this.initialize()
      } catch (error) {

      }
    }

  }

}

</script>
<style scoped>

    .text-label{
      font-weight: bold;
      font-size: 16px;
    }

</style>
